export default __webpack_public_path__ + "static/media/arrow-img.8a5479d1.svg";